import { isServer, isBrowser as isBrowser$2 } from "@qwik.dev/core/build";
const createMacroTask = (e) => {
  let t;
  if (typeof MessageChannel !== "undefined") {
    const n = new MessageChannel();
    n.port1.onmessage = () => e();
    t = () => n.port2.postMessage(null);
  } else t = () => setTimeout(e);
  return t;
};
const isBrowser$1 = !isServer;
const doc = isBrowser$1 ? document : void 0;
const config = { t: 0, o: 25, u: 0.65 };
const rel = isBrowser$1 && doc.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";
const loadStart = performance.now();
const isJSRegex = /\.[mc]?js$/;
const yieldInterval = 1e3 / 60;
const BundleImportState_None = 0;
const BundleImportState_Queued = 1;
const BundleImportState_Preload = 2;
const BundleImportState_Alias = 3;
const BundleImportState_Loaded = 4;
const bundles = /* @__PURE__ */ new Map();
let queueDirty;
let preloadCount = 0;
const queue = [];
const nextTriggerMacroTask = createMacroTask(trigger);
const nextAdjustmentMacroTask = createMacroTask(processPendingAdjustments);
let isTriggerScheduled = 0;
let isAdjustmentScheduled = 0;
let isProcessingAdjustments = 0;
const shouldYieldInBrowser = isBrowser$2;
const adjustmentStack = [];
const log = (...e) => {
  console.log(`Preloader ${performance.now() - loadStart}ms ${preloadCount}/${queue.length} queued>`, ...e);
};
const sortQueue = () => {
  if (queueDirty) {
    queue.sort((e, t) => e.l - t.l);
    queueDirty = 0;
  }
};
function trigger() {
  isTriggerScheduled = 0;
  if (!queue.length) return;
  sortQueue();
  const e = performance.now() + yieldInterval;
  let t = 0;
  while (queue.length) {
    const n = queue[0];
    const s = n.l;
    const o = 1 - s;
    const r = graph ? config.o : (
      // While the graph is not available, we limit to 5 preloads
      5
    );
    if (o >= 0.99 || preloadCount < r) {
      queue.shift();
      preloadOne(n);
      if (performance.now() >= e) {
        t = 1;
        break;
      }
    } else break;
  }
  if (t && queue.length && !isTriggerScheduled) {
    isTriggerScheduled = 1;
    nextTriggerMacroTask();
  }
  if (config.t && !queue.length) {
    const e2 = [...bundles.values()].filter((e3) => e3.i > BundleImportState_None);
    const t2 = e2.reduce((e3, t3) => e3 + t3.m, 0);
    const n = e2.reduce((e3, t3) => e3 + t3.p, 0);
    log(`>>>> done ${e2.length}/${bundles.size} total: ${t2}ms waited, ${n}ms loaded`);
  }
}
const enqueueAdjustment = (e, t, n, s) => {
  adjustmentStack.unshift({ $: e, l: t, B: s, h: n });
};
const processAdjustmentFrame = () => {
  const e = adjustmentStack[adjustmentStack.length - 1];
  const t = e.$;
  if (e.S) {
    const n2 = e.j;
    if (n2 >= e.S.length) {
      adjustmentStack.pop();
      return 0;
    }
    const s = e.S[n2];
    e.j = n2 + 1;
    const o = getBundle(s.k);
    if (o.l === 0) return 1;
    const r = 1 - t.l;
    let a;
    if (r === 1 || r >= 0.99 && e.h.T < 100) {
      e.h.T++;
      a = Math.min(0.01, 1 - s.I);
    } else {
      const e2 = 1 - s.I * r;
      const t2 = s.A;
      const n3 = e2 / t2;
      a = Math.max(0.02, o.l * n3);
      s.A = n3;
    }
    adjustmentStack.push({ $: o, l: a, B: e.B, h: e.h });
    return 1;
  }
  if (e.B?.has(t)) {
    adjustmentStack.pop();
    return 0;
  }
  const n = t.l;
  t.l = e.l;
  if (n - t.l < 0.01) {
    adjustmentStack.pop();
    return 0;
  }
  if (
    // don't queue until we have initialized the preloader
    base != null && t.i < BundleImportState_Preload
  ) {
    if (t.i === BundleImportState_None) {
      t.i = BundleImportState_Queued;
      queue.push(t);
      config.t && log(`queued ${Math.round((1 - t.l) * 100)}%`, t.k);
    }
    queueDirty = 1;
  }
  if (t.S?.length) {
    const n2 = e.B || /* @__PURE__ */ new Set();
    n2.add(t);
    e.B = n2;
    e.S = t.S;
    e.j = 0;
    return 0;
  }
  adjustmentStack.pop();
  return 0;
};
function processPendingAdjustments() {
  if (isProcessingAdjustments || !adjustmentStack.length) return;
  isAdjustmentScheduled = 0;
  isProcessingAdjustments = 1;
  const e = shouldYieldInBrowser ? performance.now() + yieldInterval : 0;
  let t = 0;
  while (adjustmentStack.length) {
    t = 1;
    const n = processAdjustmentFrame();
    if (shouldYieldInBrowser && n && performance.now() >= e) {
      if (!isAdjustmentScheduled) {
        isAdjustmentScheduled = 1;
        nextAdjustmentMacroTask();
      }
      break;
    }
  }
  isProcessingAdjustments = 0;
  if (t && shouldYieldInBrowser) nextTriggerMacroTask();
}
const preloadOne = (e) => {
  if (e.i >= BundleImportState_Preload) return;
  preloadCount++;
  const t = performance.now();
  e.m = t - e.M;
  e.i = BundleImportState_Preload;
  config.t && log(`<< load ${Math.round((1 - e.l) * 100)}% after ${`${e.m}ms`}`, e.k);
  const n = doc.createElement("link");
  n.href = new URL(`${base}${e.k}`, doc.baseURI).toString();
  n.rel = rel;
  n.as = "script";
  n.onload = n.onerror = () => {
    preloadCount--;
    const s = performance.now();
    e.p = s - t;
    e.i = BundleImportState_Loaded;
    config.t && log(`>> done after ${e.p}ms`, e.k);
    n.remove();
    nextTriggerMacroTask();
  };
  doc.head.appendChild(n);
};
const adjustProbabilities = (e, t, n) => {
  enqueueAdjustment(e, t, { T: 0 }, n);
  if (shouldYieldInBrowser) nextAdjustmentMacroTask();
  else processPendingAdjustments();
};
const handleBundle = (e, t, n) => {
  const s = getBundle(e);
  if (s && s.l > t) if (n) enqueueAdjustment(s, t, n);
  else adjustProbabilities(s, t);
};
const preload = (e, t) => {
  if (!e?.length) return;
  let n = t ? 1 - t : 0.4;
  const s = { T: 0 };
  if (Array.isArray(e)) for (let t2 = e.length - 1; t2 >= 0; t2--) {
    const o = e[t2];
    if (typeof o === "number") n = 1 - o / 10;
    else handleBundle(o, n, s);
  }
  else handleBundle(e, n, s);
  if (shouldYieldInBrowser) nextAdjustmentMacroTask();
  else processPendingAdjustments();
};
if (isBrowser$2) document.addEventListener("qsymbol", (e) => {
  const { symbol: t, href: n } = e.detail;
  if (n) {
    const e2 = t.slice(t.lastIndexOf("_") + 1);
    preload(e2, 1);
  }
});
let base;
let graph;
const isBrowser = !isServer;
const makeBundle = (e, t) => ({ k: e, i: isJSRegex.test(e) ? BundleImportState_None : BundleImportState_Alias, S: t, l: 1, M: performance.now(), m: 0, p: 0 });
const parseBundleGraph = (e) => {
  const t = /* @__PURE__ */ new Map();
  let n = 0;
  while (n < e.length) {
    const s = e[n++];
    const o = [];
    let r;
    let a = 1;
    while (r = e[n], typeof r === "number") {
      if (r < 0) a = -r / 10;
      else o.push({ k: e[r], I: a, A: 1 });
      n++;
    }
    t.set(s, o);
  }
  return t;
};
const getBundle = (e) => {
  let t = bundles.get(e);
  if (!t) {
    let n;
    if (graph) {
      n = graph.get(e);
      if (!n) return;
      if (!n.length) n = void 0;
    }
    t = makeBundle(e, n);
    bundles.set(e, t);
  }
  return t;
};
const loadBundleGraph = (e, t, n) => {
  if (n) {
    if ("d" in n) config.t = !!n.d;
    if ("P" in n) config.o = n["P"];
    if ("Q" in n) config.u = 1 - n["Q"];
  }
  if (!isBrowser || e == null) return;
  base = e;
  if (t) t.then((e2) => e2.text()).then((e2) => {
    graph = parseBundleGraph(JSON.parse(e2));
    const t2 = [];
    for (const [e3, n3] of graph.entries()) {
      const s2 = getBundle(e3);
      s2.S = n3;
      if (s2.l < 1) {
        t2.push([s2, s2.l]);
        s2.l = 1;
      }
    }
    config.t && log(`parseBundleGraph got ${graph.size} bundles, adjusting ${t2.length}`);
    if (!t2.length) {
      nextTriggerMacroTask();
      return;
    }
    let n2 = 0;
    const s = createMacroTask(() => {
      const e3 = performance.now() + yieldInterval;
      while (n2 < t2.length) {
        const [o, r] = t2[n2];
        n2++;
        adjustProbabilities(o, r);
        if (n2 < t2.length && performance.now() >= e3) {
          s();
          return;
        }
      }
      nextTriggerMacroTask();
    });
    s();
  }).catch(console.warn);
};
export {
  parseBundleGraph as g,
  handleBundle as h,
  loadBundleGraph as l,
  preload as p
};
